export function isMobile () {
  return /Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)
}

export function isAndroid () {
  return /Android/i.test(navigator.userAgent)
}

export function isIOS () {
  return /iPhone|iPad/i.test(navigator.userAgent)
}

export function isNfPlus () {
  return /NFAPP/i.test(navigator.userAgent)
}

export function isWeChat () {
  return /MicroMessenger/i.test(navigator.userAgent)
}

export function isWeChatMiniProgram () {
  const ua = navigator.userAgent.toLowerCase()
  return /micromessenger/.test(ua) && window.__wxjs_environment === 'miniprogram'
}

// 是否在打卡广东红小程序
export function isInDkgdhMiniApp (originalAppId) {
  return ['gh_263e9f43b63d', 'gh_9b3ffe5cd4e9'].includes(originalAppId)
}
